import * as React from "react";
import type { SVGProps } from "react";
const SvgAlignCenter = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M21.6 19.8H2.4m17.4-5.2H5.676M21.6 9.4H2.4m15-4.6H7.138"
    />
  </svg>
);
export default SvgAlignCenter;
